@if (shownFrom == "hol") {
  <div class="px-2">
    <div class="d-flex gap-2">
      <div class="col-12 col-lg-4">
        <div class="d-flex gap-2 py-2">
          @if (totalPinnedMessageCount > 6) {
            <div class="flex-grow-1">
              <gtapp-auto-complete
                [data]="pinnedMessageDropDownList"
                placeHolder="Search Pinned Messages"
                searchKeyword="full_name"
                [itemTemplate]="pinnedMessageTemplate"
                [initialValue]="pinnedMessageSearchString"
                (inputChanged)="onPinnedMessageLookup($event)"
                (selected)="rowClick($event)"
                (submitted)="
                  previousPinnedMessages = 0;
                  pageNumPinnedMessages = 1;
                  pinnedMessageSearchString = $event;
                  pinnedMessagePaginationData = {};
                  getPinnedMessageListData()
                "
              >
              </gtapp-auto-complete>
              <ng-template #pinnedMessageTemplate let-item>
                <div>{{ item?.full_name }}</div>
              </ng-template>
            </div>
          }

          <div class="p-2">
            <button
              class="btn btn-primary h-100"
              (click)="openAddNewPinnedMessageDialog()"
              id="addPinnedMessageButton"
            >
              + Add Pinned Message
            </button>
          </div>
        </div>

        @if (pinnedMessagePaginationData[pageNumPinnedMessages]?.length) {
          <gtapp-gt-custom-table
            [deskTopTableData]="
              pinnedMessagePaginationData[pageNumPinnedMessages]
            "
            [desktopTableDetails]="pinnedMessageDetailsTableView"
            [tableStyle]="tableStyle"
            [otherParams]="otherParamsPinnedMessages"
            (sortColumn)="sortColumnPinnedMessage($event)"
            (searchColumn)="searchColumnPinnedMessage($event)"
            (rowClick)="rowClick($event)"
            (paginationChange)="onChangePaginationPinnedMessage($event)"
            (actionClick)="onActionClick($event)"
          ></gtapp-gt-custom-table>
        }
      </div>

      @if (selectedPinnedMessage?.id || addNewMessage) {
        <div>
          <gtapp-add-edit-pinned-message
            [selectedMessageInput]="selectedPinnedMessage"
            (messageUpdated)="onMessageUpdated($event)"
          >
          </gtapp-add-edit-pinned-message>
        </div>
      }
    </div>
  </div>
} @else if (pinnedMessagePaginationData[pageNumPinnedMessages]?.length) {
  <!-- shown in home page-->
  <div class="p-2 py-3 p-lg-2">
    <dt class="mb-2">
      Pinned Messages
      @if (pinnedMessagePaginationData[pageNumPinnedMessages]?.length > 3) {
        <span (click)="routeToPinnedMessages()" class="text-center ms-3">
          <button class="btn btn-sm btn-outline-secondary bg-white">
            Show More
          </button>
        </span>
      }
    </dt>
    <div class="row row-cols-1 row-cols-lg-3">
      @for (
        pinnedMessage of pinnedMessagePaginationData[
          pageNumPinnedMessages
        ]?.slice(0, 3);
        track $index
      ) {
        <div class="col p-1">
          <div
            class="pinned-message-card h-100"
            (click)="routeToPinnedMessages()"
          >
            <div class="flex-grow-1">
              <div class="float-end"><i class="fa-solid fa-thumbtack"></i></div>
              <div class="mb-3 gt-multi-line pinned-message-text">
                @if (pinnedMessage?.pin_till) {
                  <div class="mb-2 text-danger small">
                    Shown Until:
                    {{ pinnedMessage?.pin_till | customDate: "d MMM y" }}
                  </div>
                }
                {{
                  pinnedMessage?.message?.length > 150
                    ? pinnedMessage?.message?.slice(0, 150) + "..."
                    : pinnedMessage?.message
                }}
              </div>
              <div class="d-flex gap-2 flex-wrap">
                @for (
                  item of pinnedMessage?.expandRecipients
                    ? pinnedMessage?.recipient_list
                    : pinnedMessage?.recipient_list?.slice(0, 1);
                  track $index
                ) {
                  <div class="pinned-message-recipient btn-sm px-2">
                    {{ item }}
                  </div>
                }
                @if (
                  pinnedMessage?.recipient_list?.length > 1 &&
                  !pinnedMessage?.expandRecipients
                ) {
                  <div
                    class="btn btn-outline-primary btn-sm bg-white"
                    role="button"
                    (click)="
                      pinnedMessage.expandRecipients = true;
                      $event.stopImmediatePropagation()
                    "
                  >
                    Show More
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
